import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { useGetData, useModal } from "..";
import { ENDPOINTS } from "../../constants/endpoints";
import lnMap from "../../languages/language-maps/shared-lang-map";
import { getCompanies, sortCompanies } from "../../mock/services";

function useHomeLogic() {
  const { t } = useTranslation();
  const { redirect } = useParams();
  /*   const { data } = useGetData(ENDPOINTS.GET.SERVICES,true); */
  const [data, setData] = useState();
  const { openLoginModal } = useModal();
  const [currentSortingItem, setCurrentSortingItem] = useState(
    t(lnMap.smart_sorting)
  );

  const handleSortingItemClick = (item) => {
    item.value && setData(sortCompanies(data?.hits?.data, item.value));
  };

  const tabs = useMemo(
    () => [
      {
        name: lnMap.highlights,
      },
      { name: lnMap.fast_delivery },
      { name: lnMap.new_companies },
    ],
    []
  );

  useEffect(() => {
    if (redirect) {
      openLoginModal();
    }
  }, [redirect]);

  useEffect(() => {
    setData(getCompanies());
    /* setData(getCompanies()); */
  }, []);

  return {
    tabs,
    currentSortingItem,
    setCurrentSortingItem,
    handleSortingItemClick,
    data,
  };
}

export default useHomeLogic;
